import { Button, Input, Form, Space, Row, Col, Typography } from "antd";
import { useState } from "react";

const BrandFilters = (props: any) => {
  const { applyFilters } = props;
  const [form] = Form.useForm();
  const [filters, setFilter] = useState<any>({});

  const onReset = () => {
    setFilter({});
    form.resetFields();
    applyFilters(form.getFieldsValue());
  };

  const onApply = (values: any) => {
    setFilter(values);
    applyFilters(values);
  };

  const onFinishFailed = (errorInfo: any) => {
    console.log(errorInfo);
  };
  return (
    <div>
      <div style={{ display: "flex", alignItems: "center", marginBottom: 20, gap: 10 }}>
        <Typography style={{ fontWeight: 600, fontSize: 16 }}>Use Filter</Typography>
      </div>
      <Form
        name="filter_form"
        form={form}
        onFinish={onApply}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
      >
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item label="" name="name">
              <Space.Compact style={{ width: "100%" }}>
                <Input
                  disabled
                  value={"Name"}
                  style={{
                    width: "200px",
                    color: "rgba(0, 0, 0, 0.65)",
                    cursor: "auto",
                    paddingLeft: 8
                  }}
                />
                <Form.Item name="name" noStyle>
                  <Input placeholder="Enter Name" />
                </Form.Item>
              </Space.Compact>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="" name="code">
              <Space.Compact style={{ width: "100%" }}>
                <Input
                  disabled
                  value={"Code"}
                  style={{
                    width: "200px",
                    color: "rgba(0, 0, 0, 0.65)",
                    cursor: "auto",
                    paddingLeft: 8
                  }}
                />
                <Form.Item name="code" noStyle>
                  <Input placeholder="Enter Code" />
                </Form.Item>
              </Space.Compact>
            </Form.Item>
          </Col>
        </Row>

        <div style={{ marginBottom: 20, gap: 6, display: "flex" }}>
          <Button type="default" onClick={onReset} style={{ color: "green" }}>
            Clear Filter
          </Button>
          <Button form="filter_form" key="submit" htmlType="submit" type="primary">
            Apply Filter
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default BrandFilters;
